const CarouselItems = ({ imgSrc, title, isActive }) => {
  const itemClass = `carousel-item ${isActive ? "active" : ""}`;

  return (
    <div className={itemClass}>
      <img
        src={imgSrc}
        className="d-block w-100"
        alt="carousel-img"
        style={{ height: "80vh" }}
      />
      <div
        className="carousel-caption d-none d-md-block"
        style={{ bottom: "50%" }}
      >
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default CarouselItems;
